import React from 'react';
import Select from 'react-select';

import { MultiSelectInputType } from 'src/features/CallDocuments/types/callDocumentList';

type MultiSelectInput = {
  options: Array<MultiSelectInputType> | undefined;
  size?: string;
  label: string;
  id: string;
  setSelectedOptions: (e: any) => void;
};

function ReactSelect({
  options,
  setSelectedOptions,
  size,
  id,
}: MultiSelectInput) {
  return (
    <Select
      id={id}
      options={options}
      isMulti
      closeMenuOnSelect={false}
      isSearchable={true}
      onChange={e => {
        setSelectedOptions(e);
      }}
      classNamePrefix="multiselect-dropdown"
      className={
        size === 'small'
          ? 'multiselect-dropdown multiselect-dropdown--small'
          : 'multiselect-dropdown'
      }
    />
  );
}

export { ReactSelect };
